import { APIPaths } from "../api-config";
import BaseApi from "../base-api";

export class StoreInfluencerApi extends BaseApi {
  async getInfluencerList(
    parameters: APIPaths["/store-app/influencer/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/store-app/influencer/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (
      await this.get("/store-app/influencer/list", {
        params: parameters,
      })
    ).data;
  }
  async getInfluencerById(
    id: APIPaths["/store-app/influencer/{id}"]["get"]["parameters"]["path"]["id"],
  ): Promise<APIPaths["/store-app/influencer/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/store-app/influencer/${id}`)).data;
  }
  /** 左カラムの実績（unit-api-spec#220。`storeId` は他店舗採用の基準） */
  async getInfluencerTrackRecordById(
    id: APIPaths["/store-app/influencer/{id}/track-record"]["get"]["parameters"]["path"]["id"],
    parameters: APIPaths["/store-app/influencer/{id}/track-record"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer/{id}/track-record"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`/store-app/influencer/${id}/track-record`, { params: parameters })).data;
  }
  /** IF 詳細のダッシュボード（unit-api-spec#220 RS-2。KPI・前月比・PR 完了件数の推移。`storeId` は他店舗採用の基準と所属確認、`months` は 3 / 6 / 12） */
  async getInfluencerDashboardById(
    id: APIPaths["/store-app/influencer/{id}/dashboard"]["get"]["parameters"]["path"]["id"],
    parameters: APIPaths["/store-app/influencer/{id}/dashboard"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer/{id}/dashboard"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`/store-app/influencer/${id}/dashboard`, { params: parameters })).data;
  }
  /** 店舗→IF 評価の集計（unit-api-spec#219 RS-1）。storeId は所属確認に使う */
  async getInfluencerRatingSummaryById(
    id: APIPaths["/store-app/influencer/{id}/rating/summary"]["get"]["parameters"]["path"]["id"],
    parameters: APIPaths["/store-app/influencer/{id}/rating/summary"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer/{id}/rating/summary"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`/store-app/influencer/${id}/rating/summary`, { params: parameters })).data;
  }
  /** 店舗→IF 評価の一覧（unit-api-spec#219 RS-1。他店舗はサーバーでマスキング済み） */
  async getInfluencerRatingListById(
    id: APIPaths["/store-app/influencer/{id}/rating/list"]["get"]["parameters"]["path"]["id"],
    parameters: APIPaths["/store-app/influencer/{id}/rating/list"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer/{id}/rating/list"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`/store-app/influencer/${id}/rating/list`, { params: parameters })).data;
  }
  async getFavoriteInfluencerList(
    parameters: APIPaths["/store-app/influencer/favorite/list"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer/favorite/list"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.get("/store-app/influencer/favorite/list", {
        params: parameters,
      })
    ).data;
  }
  async putFavoriteInfluencerById(
    id: APIPaths["/store-app/influencer/{id}/favorite"]["put"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer/{id}/favorite"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer/{id}/favorite"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer/${id}/favorite`, requestBody)).data;
  }
  async deleteFavoriteInfluencerById(
    id: APIPaths["/store-app/influencer/{id}/favorite"]["delete"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer/{id}/favorite"]["delete"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer/{id}/favorite"]["delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.delete(`/store-app/influencer/${id}/favorite`, {
        data: requestBody,
      })
    ).data;
  }
  async putInfluencerMemoById(
    id: APIPaths["/store-app/influencer/{id}/memo"]["put"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer/{id}/memo"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/store-app/influencer/{id}/memo"]["put"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.put(`/store-app/influencer/${id}/memo`, requestBody)).data;
  }
}
